// extracted by mini-css-extract-plugin
module.exports = {"accordion__button":"Accordion_accordion__button__6FtUG","accordion__content":"Accordion_accordion__content__16onR"};